import { Button } from '@otter-ai/den-components';
import { OtterApiIcon } from '@otter-ai/den-icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { SETTINGS_PATHS } from '@/constants/path-constants';
import { FormattedText } from '@/shared/components/FormattedText';
import { descriptionFormatRules } from '../../shared/utils/text';
import { AppRowLayout } from '../components/AppRowLayout';
import { trackOtterAPI } from '../tracking/otterAPI-tracking';

export function OtterAPIAppRow() {
  const t = useTranslations('settings:integrations.apps.otter_api');

  return (
    <AppRowLayout
      appRowId="otter-api-app"
      data-testid="otter-api-app-row"
      Icon={OtterApiIcon}
      title="Otter API"
      description={
        <FormattedText>
          {t.rich(
            'description',
            descriptionFormatRules({
              links: {
                'api-docs-link': {
                  href: t('apiDocsUrl'),
                  target: '_blank',
                  onClick: () => trackOtterAPI.main.clickViewAPIDocs(),
                },
              },
            }),
          )}
        </FormattedText>
      }
      buttons={
        <Button
          asChild
          data-testid="otter-api-key-button"
          onClick={() => trackOtterAPI.main.clickAPIKey()}
        >
          <Link href={SETTINGS_PATHS.SETTINGS_DEVELOPER}>
            {t('apiKeyButton')}
          </Link>
        </Button>
      }
    />
  );
}
